module.exports = __webpack_public_path__ + "static/media/flybridge-sofa.9289f737.webp";